import { TrackingAction } from 'src/app/core/services/tracking/models/tracking-action.enum';
import { TrackingCategory } from 'src/app/core/services/tracking/models/tracking-category.enum';
import { TrackingLabel } from 'src/app/core/services/tracking/models/tracking-label.enum';

import { createClickEventTrackingInput } from '../services/tracking/tracking.service';

export const RESOLVE_VEHICLE_HEALING_ERROR_TRACKING_DATA = {
  impressionEvent: createClickEventTrackingInput(
    TrackingLabel.ResolveVehicleHeal,
    TrackingCategory.Impression,
    TrackingAction.ConfiguratorError
  ),
  primaryOption: createClickEventTrackingInput(
    `${TrackingLabel.ResolveVehicleHeal}|${TrackingAction.NotificationPrimaryOption}`,
    TrackingCategory.Feature,
    TrackingAction.ConfiguratorError
  ),
  secondaryOption: createClickEventTrackingInput(
    `${TrackingLabel.ResolveVehicleHeal}|${TrackingAction.NotificationSecondaryOption}`,
    TrackingCategory.Feature,
    TrackingAction.ConfiguratorError
  )
};

export const RESOLVE_ONLINE_CODE_TRACKING_DATA = createClickEventTrackingInput(
  TrackingLabel.ResolveOnlineCode,
  TrackingCategory.Impression,
  TrackingAction.ConfiguratorError
);

export const GENERATE_PDF_ERROR_TRACKING_DATA = createClickEventTrackingInput(
  TrackingLabel.GeneratePdf,
  TrackingCategory.Impression,
  TrackingAction.ConfiguratorError
);

export const BUILT_TO_ORDER_ERROR_TRACKING_DATA = createClickEventTrackingInput(
  TrackingLabel.BuildToOrder,
  TrackingCategory.Impression,
  TrackingAction.ConfiguratorError
);
